import {
  styled,
  fadeIn,
  css,
  Button,
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
  SVGMol,
  SVGMolSpace,
  StitchesCSS,
} from '@moleculeone/ui';

import { useMolDrawing } from '../../../hooks';
import { CommonMol } from '../services/getCommonMols';

const fadeInClass = css({
  animation: `${fadeIn} .3s both`,
});

const FragmentIcon = styled('span', {
  pointerEvents: 'none',
});

type FragmentProps = {
  css?: StitchesCSS;
  mol: CommonMol;
  size: number;
  onPickAtom: (mol: CommonMol, defaultIdx: string) => void;
  onPickBond: (mol: CommonMol, defaultIdx: string) => void;
  active?: boolean;
  renderDelay?: number;
};
export const Fragment = ({ css, mol, size, onPickAtom, onPickBond, active, renderDelay = 0 }: FragmentProps) => {
  const drawing = useMolDrawing({ mol, renderDelay });

  const onPickFragment = e => {
    e.stopPropagation();

    if (Number.isFinite(mol.defaultAtomPickIdx)) {
      onPickAtom(mol, mol.defaultAtomPickIdx!);
    } else if (Number.isFinite(mol.defaultBondPickIdx)) {
      onPickBond(mol, mol.defaultBondPickIdx!);
    } else {
      const doubleBonds = Object.values(mol.bonds).filter(bond => {
        return bond.order > 1;
      });

      const [firstBond] = [...doubleBonds, ...Object.values(mol.bonds)];
      onPickBond(mol, firstBond.idx);
    }
  };

  return (
    <Tooltip delayDuration={300}>
      <Button
        as={TooltipTrigger}
        weight="minimal"
        size="small"
        onClick={onPickFragment}
        css={css}
        text={
          <FragmentIcon>
            {drawing == null ? (
              <div style={{ width: size, height: size }} />
            ) : (
              <SVGMolSpace viewport={drawing.viewport} width={size} height={size} className={fadeInClass()}>
                <SVGMol drawnMol={drawing.drawnMol} showWarnings={false} />
              </SVGMolSpace>
            )}
          </FragmentIcon>
        }
        data-test={`common-fragment-button-${mol.key}`}
        active={active}
        style={{ padding: '0.2rem !important', aspectRatio: 1 }}
      />
      <TooltipContent side="left">
        {mol.key}
        <TooltipArrow />
      </TooltipContent>
    </Tooltip>
  );
};
